"use client";

import Link from "next/link";
import LoginForm from "@/app/components/common/forms/LoginForm";
import { Suspense } from "react";
import AuthPhoneFormSkeleton from "@/app/components/elements/skeletons/AuthPhoneFormSkeleton";

const LoginPage = () => {
  return (
    <div className="flex items-center justify-center py-8">
      <div className="max-w-md w-[90%] mx-auto">
        <div className="text-center space-y-2 mb-8">
          <h1 className="text-2xl font-semibold text-gray-900">Hoş Geldiniz</h1>
          <p className="text-gray-600">
            Hesabınıza giriş yapın
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          <Suspense fallback={<AuthPhoneFormSkeleton />}>
            <LoginForm />
          </Suspense>
          <div className="text-center mt-6">
            <Link
              href="/"
              className="text-sm text-gray-600 hover:text-black hover:underline"
            >
              Misafir olarak devam et
            </Link>
          </div>
        </div>

        <p className="text-gray-600 text-sm mt-6 text-center">
          Henüz hesabınız yok mu?{" "}
          <Link
            href="/auth/register"
            className="text-black hover:underline font-medium"
          >
            Kayıt olun
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;